import { ReactElement, useCallback } from "react";
import { ScopeSection } from "../../ScopeSection";
import { localize } from "client_legacy/ndaw/culture";
import { Anchor } from "client/Components";
import { GlobalSearchItemPersistedModel } from "../Persistence/models";
import { TimeZone } from "client/DateAndTime/timezones";
import { ItemView } from "./Items/ItemView";
import styles from "./RecentlyOpenedView.module.less";
import { useContactDialog } from "client/Features/AddressBook/ContactDialog";
import { ContactSource } from "client/Api/Email/contacts";

export type RecentlyOpenedViewProps = {
	recentSearchResults: readonly GlobalSearchItemPersistedModel[];
	navigationIndexStart: number;
	isMobile: boolean;
	timezone: TimeZone;
	onRemove: (item: GlobalSearchItemPersistedModel) => void;
	onClear: () => void;
};

export const RecentlyOpenedView = (props: RecentlyOpenedViewProps): ReactElement => {
	const {
		recentSearchResults,
		navigationIndexStart,
		onRemove,
		onClear,
		isMobile,
		timezone
	} = props;

	const [contactDialog, openContactDialog] = useContactDialog();

	const openContactDetailsHandler = useCallback(
		(id: string, contactSource: ContactSource): void => {
			if (contactSource === ContactSource.Suggested) {
				throw new Error("Address book does not support suggested contacts");
			}

			openContactDialog({
				source: contactSource,
				initialView: {
					kind: "details",
					contactId: id
				}
			});
		},
		[openContactDialog]
	);

	return (
		<>
			<ScopeSection
				title={localize("_RecentlyOpened")}
				trackingId="recently-opened"
				titleAction={(
					<Anchor
						trackingId="clear-all"
						onClick={() => onClear()}
					>
						{localize("_ClearAll")}
					</Anchor>
				)}
			>
				<ul className={styles.list}>
					{recentSearchResults.map((item, index) => (
						<li key={index}>
							<ItemView
								item={item}
								index={index}
								navigationIndex={navigationIndexStart + index}
								isMobile={isMobile}
								timezone={timezone}
								onRemove={onRemove}
								onOpenContactDetails={openContactDetailsHandler}
							/>
						</li>
					))}
				</ul>
			</ScopeSection>
			{contactDialog}
		</>
	);
};
RecentlyOpenedView.displayName = "RecentlyOpenedView";
